import React, { useState, useEffect } from 'react';
import CenterPanel from './centerPanel';
import RightPanelTop from './rightPanelTop';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { useFormik } from 'formik';
import { useStringValidation } from 'businessLogic/helperHooks';
import RegexValidationHelper from '../../../helpers/regexValidation.js';

// There are shared states and function between center panel and right panel
function CenterAndRightPanelComponent(props) {
  const [additionalEmailMessage, setAdditionalEmailMessage] = useState(props.waURLEmailData.additionalMessage);
  const [showEmailErrorDetail, setShowEmailErrorDetail] = useState(false);
  const emailRegex = RegexValidationHelper.EMAIL_REGEX;

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validate: (values, prop) => {
      const errors = {};
      if (!values.email) {
        errors.email = 'Enter an email address';
      } else {
        let emailArray = parseEmailAddresses(values.email);
        if (emailArray.length > 1) {
          errors.email = APP.LANGUAGE.ShareURL.OneEmailAllowError;
        } else if (!emailRegex.test(values.email)) {
          errors.email = APP.LANGUAGE.ShareURL.EmailFormatError;
        }
      }

      return errors;
    },
  });

  const emailMessageCharacterLimit = 255;

  const emailMessageValidState = useStringValidation({
    checkCharacterLimt: true,
    characterLimt: emailMessageCharacterLimit,
    checkASCII: true,
    str: additionalEmailMessage,
  });

  useEffect(() => {
    if (!formik.errors.email) {
      setShowEmailErrorDetail(false);
    }
  }, [formik.errors.email]);

  const parseEmailAddresses = (emails) => {
    let emailArray = emails.split(/[\s,]+/);
    if (Array.isArray(emailArray)) {
      return emailArray;
    } else {
      return [emails];
    }
  };

  return (
    <React.Fragment>
      <div className="content body-content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel" style={{ minHeight: '400px' }}>
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanelTop
                  formik={formik}
                  waitingArea={props.waitingArea}
                  allowEdit={props.waURLEmailData.isEditAllowed}
                  parseEmailAddresses={parseEmailAddresses}
                  additionalEmailMessage={additionalEmailMessage}
                  emailMessageValidState={emailMessageValidState}
                />
              </div>
              <RightPanelBottom />
            </div>
            <CenterPanel
              waURLEmailData={props.waURLEmailData}
              waitingArea={props.waitingArea}
              formik={formik}
              showEmailErrorDetail={showEmailErrorDetail}
              setShowEmailErrorDetail={setShowEmailErrorDetail}
              additionalEmailMessage={additionalEmailMessage}
              setAdditionalEmailMessage={setAdditionalEmailMessage}
              emailMessageValidState={emailMessageValidState}
              emailMessageCharacterLimit={emailMessageCharacterLimit}
              isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
            />
            <div className="bottom-rail-with-left-and-right-content mrtl">
              <div className="mrtm">
                <RightPanelBottom />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-rail-with-left-and-right-content mrtnull">
        <RightPanelTop
          formik={formik}
          waitingArea={props.waitingArea}
          parseEmailAddresses={parseEmailAddresses}
          allowEdit={props.waURLEmailData.isEditAllowed}
          additionalEmailMessage={additionalEmailMessage}
          emailMessageValidState={emailMessageValidState}
        />
      </div>
    </React.Fragment>
  );
}

export default function ShareByEmailWaitingArea(props) {
  return (
    <Modal show={true} hideWhenClickAway={false} className="waiting-area-share-by-email fixed-header-footer-mobile">
      <PopupHeader
        title={APP.LANGUAGE.ShareURL.Title}
        subtitle={props.waitingArea.name}
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpSendWAURL}
      />
      <CenterAndRightPanelComponent
        waitingArea={props.waitingArea}
        waURLEmailData={props.waURLEmailData}
        isWAEntryPointAdditionalMsgAllowed={props.isWAEntryPointAdditionalMsgAllowed}
      />
    </Modal>
  );
}
